import { Trash } from 'lucide-react';
import { useCallback } from 'react';

import { TailwindButton } from '../../../../../tailwind';
import { useAdvancedFiltersContext } from '../AdvancedFilters.context';

import { AdvancedFiltersFieldSelect } from './AdvancedFiltersFieldSelect';
import { AdvancedFiltersOperatorSelect } from './AdvancedFiltersOperatorSelect';
import { AdvancedFiltersValueInput } from './AdvancedFiltersValueInput';

interface AdvancedFiltersConditionRowProps {
  rowId: string;
}

export const AdvancedFiltersConditionRow = ({
  rowId,
}: AdvancedFiltersConditionRowProps) => {
  const { state, dispatch } = useAdvancedFiltersContext();

  const { conditions } = state;
  const { field } = conditions[rowId];

  const shouldRemove = Object.keys(state.conditions).length > 1;

  const handleRemoveRow = useCallback(() => {
    if (shouldRemove) {
      dispatch({ type: 'REMOVE_CONDITION', payload: { rowId } });
    } else {
      dispatch({ type: 'RESET' });
    }
  }, [shouldRemove]);

  return (
    <div
      className="flex flex-row gap-2 w-full h-fit items-center"
      data-testid={`${field}-condition`}
    >
      <div className="w-full gap-2 grid grid-cols-3">
        <AdvancedFiltersFieldSelect rowId={rowId} />
        <AdvancedFiltersOperatorSelect rowId={rowId} />
        <AdvancedFiltersValueInput rowId={rowId} />
      </div>

      <TailwindButton
        data-testid={`${field}-advanced-filter-remove-button`}
        size="icon"
        variant="ghost"
        color="error"
        className="shrink-0 aspect-square rounded-full"
        onClick={handleRemoveRow}
      >
        <Trash size={18} />
      </TailwindButton>
    </div>
  );
};
